<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="export-data-sidebar items-no-padding"
    spacer
    v-model="visible"
  >
    <div class="flex items-center justify-between px-6 mt-6">
      <h5>Export Transactions</h5>
      <feather-icon
        icon="XIcon"
        @click.stop="$emit('closeSidebar')"
        class="cursor-pointer"
      ></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6" v-if="!json_data">Preparing data...</div>
      <div class="p-6" v-if="json_data && !this.isOkMobile">
        Data is ready, please click Download.
      </div>
      <div class="p-6" v-if="json_data && this.isOkMobile">
        Data is ready, please click Send to OKMobile.
      </div>
    </component>

    <div
      v-if="!this.isOkMobile"
      class="flex flex-wrap items-center p-6"
      slot="footer"
    >
      <download-csv class="" :data="json_data" name="transaction-export.csv">
        <vs-button class="mr-3">Download</vs-button>
      </download-csv>
      <vs-button type="border" color="dark" @click="$emit('closeSidebar')"
        >Back</vs-button
      >
    </div>
    <div
      v-else-if="this.isOkMobile"
      class="flex flex-wrap items-center p-6"
      slot="footer"
    >
      <vs-button @click="submitOkMobile()" class="mr-3"
        >Send to OKMobile</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import GenericUpload from '@/views/components/override/GenericUpload.vue'
import vSelect from 'vue-select'
import LoadingDefault from '@/views/components/vuesax/loading/LoadingDefault.vue'
import JsonCSV from 'vue-json-csv'
import * as moment from 'moment'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Object,
      default: () => {},
    },
    toExports: {
      type: Array,
      default: () => [],
    },
    toExport: {
      type: String,
    },
  },
  components: {
    JsonCSV,
    VuePerfectScrollbar,
    GenericUpload,
    vSelect,
    LoadingDefault,
  },
  data() {
    return {
      isUpdate: false,
      isOkMobile: false,
      // perfect scrollbar settings
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      json_data: [],
      transactions: [],
      okMobilePayload: [],
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
  },
  created() {
    this.isOkMobile =
      this.$store.state.AppActiveUser.activeTenant ===
        'e1706620-e0ed-4882-bfc1-532f9cd6de4a' ||
      this.$store.state.AppActiveUser.activeTenant ===
        'bbbe9649-b96b-4718-929c-357e463fe160'
    this.fetchRecord()
  },
  methods: {
    async fetchRecord() {
      this.toExports.forEach(te => {
        if (this.toExport !== undefined)
          this.toExport = this.toExport + ',' + te.id
        else this.toExport = te.id
      })
      const res = await this.$store.dispatch('transactions/fetchRecords', {
        s: this.search,
        filter: `id||$in||${this.toExport}`,
      })
      this.json_data = []
      this.transactions = []
      res.data.forEach(transaction => {
        transaction.items.forEach(item => {
          this.json_data.push({
            paymentReferenceId: transaction.paymentReference
              ? transaction.paymentReference
              : transaction.id,
            receiptReferenceId: transaction.id,
            transactionDescription: '',
            type: transaction.provider
              ? transaction.provider
              : transaction.type,
            currency: transaction.currency,
            paidAt: transaction.paidAt
              ? moment
                  .utc(transaction.paidAt)
                  .clone()
                  .format('yyyy-MM-DD HH:mm:ss')
              : '',
            payerCustomerId: transaction.customerId
              ? transaction.customerId
              : '',
            customerId: item.customerId ? item.customerId : '',
            docType: item.docType ? item.docType : '',
            docNo: item.docNo ? item.docNo : '',
            amount: item.amount,
          })
        })
        this.transactions.push({
          id: transaction.id,
          isExport: true,
        })
        this.okMobilePayload.push(transaction.id)
      })
      const updateRes = await this.$store.dispatch(
        'transactions/addRecords',
        this.transactions
      )
    },
    async submitOkMobile() {
      await this.$store
        .dispatch('transactions/approveRecords', this.okMobilePayload)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Payment Has Been Submitted',
            text: 'Your payment has been submitted successfully.',
          })
          this.$emit('closeSidebar')
          this.$router.go()
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/apps/export-csv.scss';
</style>
